export function issueCommentAnchor(commentId: string, anchorPrefix?: string): string {
  return `${anchorPrefix ?? ''}issuecomment-${commentId}`
}

export function reviewSummaryAnchor(reviewId: string | number, anchorPrefix?: string): string {
  return `${anchorPrefix ?? ''}pullrequestreview-${reviewId}`
}

export function parseConversationItemHash(hash: string): {type: 'issue' | 'review_summary'; id: string} | null {
  const match = /^#(issuecomment|pullrequestreview)-(\d+)$/.exec(hash)
  const id = match?.[2]
  if (!id) return null

  return {type: match[1] === 'pullrequestreview' ? 'review_summary' : 'issue', id}
}

export function threadCommentAnchorPrefix(anchorPrefix?: string): string {
  // This matches the canonical public review-comment fragment.
  return `${anchorPrefix ?? ''}discussion_r`
}

export function threadCommentAnchor(commentId: string, anchorPrefix?: string): string {
  return `${threadCommentAnchorPrefix(anchorPrefix)}${commentId}`
}
